import React from "react"
import { Button } from 'primereact/button';
import { Dialog } from "primereact/dialog";
import { FormSectionElements, FormSections, FormSubSections, LOVValues } from "../../entities/formTemplateDataType";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { dateComparisonList, FR_SUFFIX, odsCallOutBoxs } from "../../entities/Constants";
import { Editor } from "primereact/editor";
import { MultiSelect } from "primereact/multiselect";
import Utils from "../../utilities/Utils";
import { InputTextarea } from "primereact/inputtextarea";
import { DialogBase, Props, State } from "./DialogBase";



export class DialogForLabelComponent extends DialogBase<Props,State> {

    dateTypeFieldList = [];
    subSection: FormSubSections;
    additionalHtmlString = [];

    constructor(props: Props) {
        super(props);

        this.subSection = this.props.ele.parent as FormSubSections;
        this.dateTypeFieldList = this.subSection.ListOfFormSectionElements?.filter(p => p.Datatype === 'Date' && p.Sequence < this.props.ele.Sequence);
    }


    generateHtmlString = () => {
        let html = [];
        let contentHtml = this.otherPreviousFields();

        if (this.additionalHtmlString.length > 0) {
            contentHtml.push(this.additionalHtmlString);
            // this.additionalHtmlString=[];
        }

        html.push(
            <>
                {/* @ts-ignore */}
                <Dialog
                    header={this.props.isEng ? "Field Properties for " + this.props.ele.ENUTitle : "Field Properties for " + this.props.ele.FRATitle} 
                    footer={this.renderFooter()}
                    visible={this.props.dialogVisible} style={{ width: '50vw' }}
                    onHide={() => this.props.callback(false)}
                >
                    {contentHtml}
                </Dialog>
            </>
        );
        return html;
    }


    otherPreviousFields = () => {
        let htmlString = [];

        htmlString.push(
            <div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"tbl_" + this.props.ele.Sequence}>Field</label>
                    </div>
                    <div style={{ width: '60%', }}>
                        <InputText key={"tbl_" + this.props.ele.Sequence} value={this.props.ele.UpdateField} className="ontario-input"
                            onChange={(e) => { this.props.ele.UpdateField = e.target.value; this.props.callback() }} />
                    </div>
                </div>

                {this.questionHintHtml()}

                {this.tooTipHtml()}

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Wrap in Callout box</div>
                    <div style={{ width: '60%', }}>
                        {/* @ts-ignore */}
                        <Dropdown showClear className="ontario-dropdown-small" 
                            options={odsCallOutBoxs} 
                            optionLabel='label' 
                            optionValue='val' 
                            value={this.props.ele.wrapCalloutbox} 
                            onChange={(e) => {
                                this.props.ele.wrapCalloutbox = e.value;
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>

                {this.calloutBoxHtml()}

                {this.stepperScriptHtml()}

                {this.scriptHtml()}
                {this.fieldOnTopHtml()}
            </div>
        )

        htmlString.push(this.generateFilter());

        return htmlString;
    }

    generateFilter = () => {
        let html = [];
        let allElements = [];
        let elementListWithOptions = [];

        let section = this.subSection.parent as FormSections;
        //get the section list prior to this one
        if (section.ListOfFormSubSections && Array.isArray(section.ListOfFormSubSections)) {
            section.ListOfFormSubSections.forEach(sub => {
                let elementList = sub.ListOfFormSectionElements.filter(p => {
                    const isSameSubSection = sub.Sequence === this.subSection.Sequence;
                    const isEarlierSubSection = sub.Sequence < this.subSection.Sequence;
                    return (p.Sequence < this.props.ele.Sequence && isSameSubSection) || isEarlierSubSection;
                });
                allElements.push(...elementList);
            });
        }

        let list = allElements.filter(
            (q) =>
                (q.Datatype === "RadioButton" ||
                q.Datatype === "CheckGroup" ||
                q.Datatype === "Dropdown")
        ).map((q) => {
            return {
                code: q.LoadBindName,
                description: this.props.isEng ? q.ENUTitle : q.FRATitle
            };
        });

        elementListWithOptions.push(...list);
    
        if (this.props.ele.FilterField == null || this.props.ele.FilterField == undefined) {
            this.props.ele.FilterField = [];

        }
        for (let option of elementListWithOptions) {
        
            let optionList = allElements.filter(p => p.LoadBindName == option["code"])[0].ListOfLOVValues;
            if (this.props.ele.FilterField.indexOf(option["code"]) == -1) {
                this.props.ele.FilterField.push(option["code"])
            }
            html.push(
                <>
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>Filtering Field</div>
                        <div style={{ width: '60%' }}>{this.props.isEng ? option["description"] : option["FRADescription"]}</div>
                    </div>
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>Filtering Value</div>
                        <div style={{ width: '60%', }}>
                            <div>
                                {/* @ts-ignore */}
                                <MultiSelect style={{ width: '100%' }}
                                    className="ontario-dropdown-small"
                                    options={optionList}
                                    value={this.props.isEng ?
                                        (this.props.ele.FilterValue ? this.props.ele.FilterValue[option.code] : null) :
                                        (this.props.ele.FilterValueFRA ? this.props.ele.FilterValueFRA[option.code] : null)}
                                    optionLabel={this.props.isEng ? "description" : "FRADescription"}
                                    optionValue="code"
                                    placeholder="Filtering value"
                                    onChange={(e) => {

                                        if (Utils.isNullOrEmpty(this.props.ele.FilterValue))
                                            this.props.ele.FilterValue = {};
                                        if (this.props.isEng) {
                                            // if (this.props.ele.FilterValue[this.props.ele.FilterField]==null) {
                                            //     let obj = { [this.props.ele.FilterField]: e.value };
                                            //     this.props.ele.FilterValue.push(obj);
                                            //     console.log(this.props.ele);
                                            // } else {
                                            this.props.ele.FilterValue[option.code] = e.value;

                                            // }
                                        } else {

                                            if (this.props.ele.FilterValueFRA == null) {
                                                this.props.ele.FilterValueFRA = [];
                                            }
                                            this.props.ele.FilterValueFRA[option.code] = e.value;

                                        }
                                        this.props.callback();
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </>
            )


        }
        return html;
    }

    renderFooter = () => {
        return (
            <div>
                {/* @ts-ignore */}
                <Button label="OK" icon="pi pi-check" onClick={() => {
                    this.props.callback(false);
                }} />
                {/* @ts-ignore */}
                <Button label="Cancel" onClick={() => { this.props.callback(false) }} />

            </div>
        );
    }

    render() {
        return (
            this.generateHtmlString()
        )
    }
}
